import { render, staticRenderFns } from "./MedicalPracticeList.vue?vue&type=template&id=744f82a6&scoped=true&lang=pug"
import script from "./MedicalPracticeList.vue?vue&type=script&lang=js"
export * from "./MedicalPracticeList.vue?vue&type=script&lang=js"
import style0 from "./MedicalPracticeList.vue?vue&type=style&index=0&id=744f82a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744f82a6",
  null
  
)

export default component.exports